module.exports = __webpack_public_path__ + "static/media/emailAlert.dcfe9522.svg";